import React from 'react';
import classnames from 'classnames';
import s from './FlexItem.scss';

export interface Props {
  className?: string;
  style?: React.CSSProperties;
  grow?: boolean;
  shrink?: boolean;
  justifySelf?:
    | 'center'
    | 'flex-start'
    | 'flex-end'
    | 'baseline'
    | 'space-between'
    | 'space-around'
    | 'space-evenly';
  alignSelf?: 'stretch' | 'center' | 'flex-start' | 'flex-end' | 'baseline';
  basis?: string;
  order?: number;
  innerRef?: React.Ref<HTMLDivElement>;
  'aria-label'?: string;
}

const FlexItem: React.FC<React.PropsWithChildren<Props>> = props => {
  const classNames = classnames(
    s['root'],
    props.order && s[`order-${props.order}`],
    props.grow && s['grow'],
    props.shrink && s['shrink'],
    props.justifySelf && s[`justify-self-${props.justifySelf}`],
    props.alignSelf && s[`align-self-${props.alignSelf}`],
    props.className
  );
  const flexBasis = props.basis ? props.basis : 'auto';
  const style = { ...props.style, flexBasis };
  return (
    <div className={classNames} style={style} ref={props.innerRef} aria-label={props['aria-label']}>
      {props.children}
    </div>
  );
};
FlexItem.displayName = 'FlexItem';

export default FlexItem;
